(() => {
  if (window.BoccProductCardPurchase) return;
  window.BoccProductCardPurchase = true;

  const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const purchases = () => document.querySelectorAll('[data-bocc-card-purchase]');
  let cartRequest = null;

  const quantityForVariant = (cart, variantId) => (cart.items || [])
    .filter((item) => String(item.variant_id) === String(variantId) && !item.selling_plan_allocation)
    .reduce((total, item) => total + item.quantity, 0);

  const setQuantity = (purchase, quantity) => {
    const addButton = purchase.querySelector('[data-bocc-card-add]');
    const qtyWrap = purchase.querySelector('[data-bocc-card-qty]');
    const qtyValue = purchase.querySelector('[data-bocc-card-qty-value]');
    const minusButton = purchase.querySelector('[data-bocc-card-qty-minus]');
    if (!addButton || !qtyWrap || !qtyValue) return;

    const inCart = quantity > 0;
    addButton.hidden = inCart;
    qtyWrap.hidden = !inCart;
    qtyValue.textContent = String(quantity);
    if (minusButton) {
      minusButton.setAttribute('aria-label', quantity === 1 ? 'Remove from cart' : 'Decrease quantity');
    }
  };

  const renderCart = (cart) => {
    purchases().forEach((purchase) => {
      setQuantity(purchase, quantityForVariant(cart, purchase.dataset.variantId));
    });

    const count = cart.item_count || 0;
    document.querySelectorAll('[data-bocc-header-cart-count], .cart-count, [data-cart-count], .site-header__cart-count, .header-cart-count').forEach((element) => {
      element.textContent = String(count);
      element.classList.toggle('is-hidden', count === 0);
    });
  };

  const refreshOpenDrawer = () => {
    const drawer = document.querySelector('.bocc-cart');
    if (drawer && drawer.classList.contains('is-open') && typeof window.BoccCartOpen === 'function') {
      window.BoccCartOpen({ refresh: true });
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${cartRoot()}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart could not be loaded');
    return response.json();
  };

  const syncFromCart = async () => {
    if (!purchases().length) return;

    try {
      renderCart(await fetchCart());
    } catch (error) {
      console.error('Product card cart sync failed', error);
    }
  };

  const setBusy = (purchase, busy) => {
    purchase.querySelectorAll('button').forEach((button) => {
      button.disabled = busy;
    });
  };

  const mutateCart = (purchase, request, { openCart = false } = {}) => {
    if (cartRequest) return;

    setBusy(purchase, true);
    cartRequest = request()
      .then((cart) => {
        renderCart(cart);
        if (openCart && typeof window.BoccCartOpen === 'function') {
          window.BoccCartOpen({ refresh: true, trigger: purchase.querySelector('[data-bocc-card-add]') });
          return;
        }
        refreshOpenDrawer();
      })
      .catch((error) => {
        console.error('Product card cart update failed', error);
      })
      .finally(() => {
        cartRequest = null;
        setBusy(purchase, false);
      });
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-bocc-card-add]');
    if (addButton) {
      const purchase = addButton.closest('[data-bocc-card-purchase]');
      if (!purchase) return;

      mutateCart(purchase, async () => {
        const response = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(purchase.dataset.variantId), quantity: 1 }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return fetchCart();
      }, { openCart: true });
      return;
    }

    const minusButton = event.target.closest('[data-bocc-card-qty-minus]');
    const plusButton = event.target.closest('[data-bocc-card-qty-plus]');
    if (!minusButton && !plusButton) return;

    const purchase = (minusButton || plusButton).closest('[data-bocc-card-purchase]');
    const qtyValue = purchase && purchase.querySelector('[data-bocc-card-qty-value]');
    if (!purchase || !qtyValue) return;

    const current = Number(qtyValue.textContent) || 0;
    const nextQuantity = plusButton ? current + 1 : Math.max(0, current - 1);

    mutateCart(purchase, async () => {
      const response = await fetch(`${cartRoot()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: purchase.dataset.variantId, quantity: nextQuantity }),
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Cart could not be updated');
      return cart;
    });
  });

  document.documentElement.addEventListener('cart:updated', (event) => {
    if (event.detail && event.detail.cart) renderCart(event.detail.cart);
  });
  document.addEventListener('bocc:cards:rendered', syncFromCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }

  document.addEventListener('shopify:section:load', syncFromCart);
})();
